<!-- <div class="template animated slideInRight">
    <div class="container-fluid">
        <div class="card card-outline-primary">
            <div class="card-block">
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <td width="20%">{{ 'CODE' | translate }} </td>
                            <td>{{ 'Name' | translate }}</td>
                            <td>{{ 'RELATIVEDEGREE' | translate }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let member of familyDetails">
                            <td width="20%">{{member.patientCode}}</td>
                            <td>{{translate.currentLang == 'ar'? member.fullnameAr : member.fullnameEn }}</td>
                            <td>{{translate.currentLang == 'ar'? member.relativeNameAr : member.relativeNameEn }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</div> --> 

<div class="container">
    <h2 class="my-3">{{translate.currentLang == 'ar' ? 'بيانات العائلة' : 'Family Details'}}</h2>
    <p class="my-2">{{translate.currentLang == 'ar' ? 'فى هذا الجدول يتم عرض بيانات عائلة المريض....' : 'In this table, We Display Patient Family Details....'}}</p>
    <table class="table table-hover table-bordered" style="box-shadow: 2px 4px 12px rgba(0,0,0,0.25)">
        <thead>
            <tr>
                <th class="bg-info" width="20%">{{ 'CODE' | translate }} </th>
                <th class="bg-info">{{ 'Name' | translate }}</th>
                <th class="bg-info">{{ 'RELATIVEDEGREE' | translate }}</th>
                <th class="bg-info"></th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let member of familyDetail;">
                <td class="py-2" width="20%">{{member.patientCode}}</td>
                <td>{{translate.currentLang == 'ar'? member.fullnameAr : member.fullnameEn }}</td>
                <td>{{translate.currentLang == 'ar'? member.relativeNameAr : member.relativeNameEn }}</td>
                <td>
                   
                <i style="margin-left:50%;margin-right:50%;" class="fa fa-trash fa-2x" (click)="onRowIconClick($event , member)" placement="top" ngbTooltip="{{ 'DELETE' | translate }}">

                </i>

                </td>
            </tr>
        </tbody>
    </table>
</div>